export async function setRouterName({commit}, status) {
  commit('setRouterName', status);
}
